<template>
  <ValidationProvider
    :name="$attrs.label"
    :rules="{ required: { allowFalse: false } }"
  >
    <v-checkbox
      :disabled="$attrs.disabled"
      v-bind="$attrs"
      v-model="innerValue"
      v-on="$listeners"
    >
      <template v-slot:label>
        <slot name="label"></slot>
      </template>
    </v-checkbox>
  </ValidationProvider>
</template>

<script>
import { ValidationProvider } from "vee-validate";

export default {
  components: {
    ValidationProvider,
  },
  props: {
    rules: {
      type: [Object, String],
      default: "",
    },
    // must be included in props
    value: {
      type: null,
    },
  },
  data: () => ({
    innerValue: "",
    showMoreInfo: false,
  }),
  watch: {
    // Handles internal model changes.
    innerValue(newVal) {
      this.$emit("input", newVal);
    },
    // Handles external model changes.
    value(newVal) {
      this.innerValue = newVal;
    },
  },
  methods: {
    toggleInfo() {
      this.showMoreInfo = !this.showMoreInfo;
    },
  },
  created() {
    if (this.value) this.innerValue = this.value;
    if (!this.value && this.$attrs.default) {
      this.innerValue = this.$attrs.default || "";
    }
  },
};
</script>
<style scoped>
.additional-info {
  margin-top: 10px;
}
.more-info-link {
  color: blue;
  cursor: pointer;
  text-decoration: underline;
}
.more-info-text {
  margin-top: 10px;
  font-size: 14px;
  color: #565656;
}
</style>
